"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Item = function (props) {
    var title = props.title, backgroundImage = props.backgroundImage, backgroundColor = props.backgroundColor, description = props.description, link = props.link, linkText = props.linkText, extendProps = props.extendProps;
    function renderFooterLink(linkText, link, extendProps) {
        if (!linkText) {
            return null;
        }
        return (react_1.default.createElement("a", __assign({ className: "footer-link", href: link }, (extendProps || {}), { target: "_blank", rel: "noreferrer" }),
            linkText,
            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "12", viewBox: "0 0 15 12", fill: "none" },
                react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 1.48679L8.58871 0L15 6L8.58871 12L7 10.5132L10.8921 7H0V5H10.8921L7 1.48679Z", fill: "currentColor" }))));
    }
    return (react_1.default.createElement("div", { className: "list__warp" },
        react_1.default.createElement("div", { style: { background: backgroundColor }, className: "list__items" },
            react_1.default.createElement("strong", { className: "list__title" }, title),
            react_1.default.createElement("span", { className: "list__description" }, description),
            backgroundImage && react_1.default.createElement("img", { className: "list_backgroundImg", src: backgroundImage, alt: "" }),
            renderFooterLink(linkText, link, extendProps))));
};
exports.default = Item;
//# sourceMappingURL=Item.js.map